import React from 'react';
import Layout from '../components/Layout';
import { Typography } from '@mui/material';
import { RouteComponentProps } from 'react-router';
import DocsTerms from '../components/DocsTerms';
import { useTranslation } from 'react-i18next';

/**
 * User agreement
 * @param props
 */
export default function(props: RouteComponentProps<{ lng: string }>) {
  const { t } = useTranslation('translation');
  return (
    <Layout maxWidth="lg" showFooter={false}>
      <Typography variant="h6">{t('termsOfUse')}</Typography>
      <DocsTerms lng={props.match.params.lng} />
    </Layout>
  );
}
